import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import ViewInfo from "./ViewPanelDetails.module.css";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import axios from "axios";
import fileDownload from "js-file-download";
import { ImageUrlPrefix } from "../../../../../labels";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export default function ViewPanelInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  // get user id
  const userJSON = sessionStorage.getItem("userDetails");
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      user_type = user?.user_type;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  const {
    PANELID,
    MARKSTATUS,
    BATCHID,
    INTERVIEWID,
    FCAT,
    FCOURSE,
    FSTATUS,
    FSEARCH,
    FDATE,
    FILTER_BATCH_NAME,
    FILTER_GENDER,
    FILTER_MEDIUM,
    FILTER_CORE_SUBJECT,
    FILTER_STUDENT_STATUS,
    FILTER_CHIP_DATA,
    PANEL_MARK_STATUS,
    SHOW_INTERVIEW_DETAILS,
    TYPE,
    PAGE_FROM,
    ID,
  } = location.state || {};

  const id = PANELID || params.panelId || params.id;
  const [interviewId, setInterViewId] = useState(INTERVIEWID || "");
  const [batchId, setBatchId] = useState(BATCHID || "");
  const [enrollMent, setEnrollMent] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isStudentLoading, setIsStudentLoading] = useState(false);

  // Pagination State for Enrolled Students
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Sorting States for Panel Members
  const [panelMemberSortOrder, setPanelMemberSortOrder] = useState("asc");
  const [panelMemberSortKey, setPanelMemberSortKey] = useState("");

  // Sorting States for Enrolled Students
  const [studentSortOrder, setStudentSortOrder] = useState("asc");
  const [studentSortKey, setStudentSortKey] = useState("");

  // Interview Details State
  const [interviewDetails, setInterviewDetails] = useState({
    exam_title: "",
    started_dt: "",
    category: "",
    course_name: "",
    syllabus_url: "",
    syllabus_name: "",
    result_status: "",
    category_course_id: "",
    syllabus_path: "",
  });

  // Panel Details State
  const [panelDetails, setPanelDetails] = useState({
    panel_name: "",
    panel_venue: "",
    panel_venue_url: "",
    core_subject: "",
    interview_date: "",
    start_time: "",
    end_time: "",
    slot_duration: "",
    student_count: 0,
    mark_status: "",
  });

  // Other Applicable Batches
  const [otherApplicableBatches, setOtherApplicableBatches] = useState("");

  // Panel Members State
  const [panelMembers, setPanelMembers] = useState([]);
  const [filteredPanelMembers, setFilteredPanelMembers] = useState([]);

  // Enrolled Students State
  const [enrolledStudents, setEnrolledStudents] = useState([]);
  const [originalEnrolledStudents, setOriginalEnrolledStudents] = useState([]);

  // Filter Refs
  const memberStatusRef = useRef(null);
  const batchNameRef = useRef(null);
  const genderRef = useRef(null);
  const mediumRef = useRef(null);
  const coreSubjectRef = useRef(null);
  const studentStatusRef = useRef(null);

  // Panel Members Filter State
  const [memberStatusFilter, setMemberStatusFilter] = useState([]);
  const [tempMemberStatus, setTempMemberStatus] = useState([]);
  const [isMemberStatusOpen, setIsMemberStatusOpen] = useState(false);

  // Enrolled Students Filter States
  const [batchNameFilter, setBatchNameFilter] = useState(
    FILTER_BATCH_NAME || []
  );
  const [tempBatchName, setTempBatchName] = useState(FILTER_BATCH_NAME || []);
  const [isBatchNameOpen, setIsBatchNameOpen] = useState(false);

  const [genderFilter, setGenderFilter] = useState(FILTER_GENDER || []);
  const [tempGender, setTempGender] = useState(FILTER_GENDER || []);
  const [isGenderOpen, setIsGenderOpen] = useState(false);

  const [mediumFilter, setMediumFilter] = useState(FILTER_MEDIUM || []);
  const [tempMedium, setTempMedium] = useState(FILTER_MEDIUM || []);
  const [isMediumOpen, setIsMediumOpen] = useState(false);

  const [coreSubjectFilter, setCoreSubjectFilter] = useState(
    FILTER_CORE_SUBJECT || []
  );
  const [tempCoreSubject, setTempCoreSubject] = useState(
    FILTER_CORE_SUBJECT || []
  );
  const [isCoreSubjectOpen, setIsCoreSubjectOpen] = useState(false);

  const [studentStatusFilter, setStudentStatusFilter] = useState(
    FILTER_STUDENT_STATUS || []
  );
  const [tempStudentStatus, setTempStudentStatus] = useState(
    FILTER_STUDENT_STATUS || []
  );
  const [isStudentStatusOpen, setIsStudentStatusOpen] = useState(false);

  // Chip Data States
  const [memberChipData, setMemberChipData] = useState([]);
  const [studentChipData, setStudentChipData] = useState(
    FILTER_CHIP_DATA || []
  );

  // Filter Options
  const [batchNameOptions, setBatchNameOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [mediumOptions, setMediumOptions] = useState([]);
  const [coreSubjectOptions, setCoreSubjectOptions] = useState([]);

  const memberStatusOptions = [
    { id: "updated", name: "Updated" },
    { id: "not_updated", name: "Not Yet Updated" },
  ];

  const studentStatusOptions = [
    { id: 0, name: "Not Yet Updated " },
    { id: 1, name: "Updated" },
    { id: 2, name: "Absent" },
  ];

  // Pagination Calculations
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentStudentData = enrolledStudents.slice(start, end);
  const totalPages = Math.ceil(enrolledStudents.length / rowsPerPage);

  // Format time to 12-hour format
  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "";
    const timeParts = time24.split(":");
    if (timeParts.length < 2) return time24;
    let hour = parseInt(timeParts[0], 10);
    const minutes = timeParts[1];
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12;
    const formattedHour = hour.toString().padStart(2, "0");
    return formattedHour + ":" + minutes + " " + ampm;
  };

  // Format slot duration
  const formatSlotDuration = (duration) => {
    if (!duration) return "";
    const parts = duration.split(":");
    if (parts.length >= 2) {
      const minutes = parseInt(parts[1], 10);
      return minutes.toString();
    }
    return duration;
  };

  // Helper function to get mark status display for panel members
  const getPanelMemberMarkStatus = (member) => {
    const totalCount = member.total_count || 0;
    const updateCount = member.update_count || 0;
    const status = member.status;

    // status: 1 = Updated, status: 0 = Not Yet Updated
    if (status === 1) {
      return {
        text: `Updated (${updateCount}/${totalCount})`,
        isUpdated: true,
      };
    } else {
      return {
        text: `Not Yet Updated (${updateCount}/${totalCount})`,
        isUpdated: false,
      };
    }
  };

  // Helper function to get mark status display for enrolled students
  const getStudentMarkStatus = (student) => {
    const totalPanelCount = Number(student.total_panel_count) || 0;
    const panelMarkCount = Number(student.panel_mark_count) || 0;

    const studStatus = Number(student.stud_status);

    // ✅ Absent check (highest priority)
    if (studStatus === 2) {
      return {
        text: "Absent",
        status: "absent",
      };
    }

    // ✅ All panel marks updated
    if (studStatus === 1) {
      return {
        text: `Updated (${panelMarkCount}/${totalPanelCount})`,
        status: "updated",
      };
    }

    // ✅ Pending marks
    return {
      text: `Not Yet Updated (${panelMarkCount}/${totalPanelCount})`,
      status: "not_updated",
    };
  };

  // ============== SORTING FUNCTIONS ==============

  // Sort Panel Members
  const handleSortPanelMembers = (event, sortKey) => {
    event.preventDefault();

    const order =
      panelMemberSortKey === sortKey && panelMemberSortOrder === "asc"
        ? "desc"
        : "asc";
    setPanelMemberSortOrder(order);
    setPanelMemberSortKey(sortKey);

    const sortedList = [...filteredPanelMembers].sort((a, b) => {
      let valueA = a[sortKey];
      let valueB = b[sortKey];

      // Special handling for mark_status sorting - sort by update ratio
      if (sortKey === "mark_status") {
        const ratioA = a.total_count > 0 ? a.update_count / a.total_count : 0;
        const ratioB = b.total_count > 0 ? b.update_count / b.total_count : 0;
        valueA = ratioA;
        valueB = ratioB;
      }

      // Handle null/undefined values
      if (valueA === null || valueA === undefined) valueA = "";
      if (valueB === null || valueB === undefined) valueB = "";

      // Convert to lowercase for string comparison
      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) {
        return order === "asc" ? -1 : 1;
      }
      if (valueA > valueB) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });

    setFilteredPanelMembers(sortedList);
  };

  // Sort Enrolled Students
  const handleSortStudents = (event, sortKey) => {
    event.preventDefault();

    const order =
      studentSortKey === sortKey && studentSortOrder === "asc" ? "desc" : "asc";
    setStudentSortOrder(order);
    setStudentSortKey(sortKey);

    const sortedList = [...enrolledStudents].sort((a, b) => {
      let valueA = a[sortKey];
      let valueB = b[sortKey];

      // Special handling for mark_status sorting - sort by update ratio
      if (sortKey === "mark_status") {
        const ratioA =
          a.total_panel_count > 0
            ? a.panel_mark_count / a.total_panel_count
            : 0;
        const ratioB =
          b.total_panel_count > 0
            ? b.panel_mark_count / b.total_panel_count
            : 0;
        valueA = ratioA;
        valueB = ratioB;
      }

      // Handle null/undefined values
      if (valueA === null || valueA === undefined) valueA = "";
      if (valueB === null || valueB === undefined) valueB = "";

      // Convert to lowercase for string comparison
      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) {
        return order === "asc" ? -1 : 1;
      }
      if (valueA > valueB) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });

    setEnrolledStudents(sortedList);
  };

  // ============== END SORTING FUNCTIONS ==============

  // ============== API FILTER FUNCTIONS ==============

  // Build filter payload from chip data
  // Build filter payload from current filter states (like Listview pattern)
  // Build filter payload from current filter states (like Listview pattern)
  const buildFilterPayloadFromStates = (
    batchFilter = [],
    genderFilterArr = [],
    mediumFilterArr = [],
    coreSubjectFilterArr = [],
    studentStatusFilterArr = [],
    memberStatusFilterArr = [] // ADD THIS PARAMETER
  ) => {
    // Build arrays like Listview does
    let tempGender = [];
    let tempBatchName = [];
    let tempCoreSubject = [];
    let tempStudentStatus = [];

    genderFilterArr.forEach((obj) => {
      tempGender.push(obj.name);
    });

    batchFilter.forEach((obj) => {
      tempBatchName.push(obj.name);
    });

    coreSubjectFilterArr.forEach((obj) => {
      tempCoreSubject.push(obj.name);
    });

    // For student_mark_status: send array of numbers [0, 1, 2]
    studentStatusFilterArr.forEach((obj) => {
      tempStudentStatus.push(obj.id);
    });

    // For medium_studied: send single string (not array)
    let mediumValue = "";
    if (mediumFilterArr.length > 0) {
      mediumValue = mediumFilterArr[0].name;
    }

    let panelMarkStatusValue = "";
    if (memberStatusFilterArr.length === 1) {
      if (memberStatusFilterArr[0].id === "updated") {
        panelMarkStatusValue = 1;
      } else if (memberStatusFilterArr[0].id === "not_updated") {
        panelMarkStatusValue = 0;
      }
    }
    // If length is 0 or 2 (both selected), keep empty string

    return {
      gender: genderFilterArr.length > 0 ? tempGender : "",
      batch_name: batchFilter.length > 0 ? tempBatchName : "",
      medium_studied: mediumValue,
      core_subject: coreSubjectFilterArr.length > 0 ? tempCoreSubject : "",
      student_mark_status:
        studentStatusFilterArr.length > 0 ? tempStudentStatus : "",
      panel_mark_status: panelMarkStatusValue, // ADD THIS
    };
  };

  // Fetch Panel Data with filters
  const fetchPanelDataWithFilters = async (
    filters = {},
    isInitialLoad = false
  ) => {
    if (!id) {
      console.error("Panel ID is missing");
      setIsLoading(false);
      return;
    }

    if (isInitialLoad) {
      setIsLoading(true);
    } else {
      setIsStudentLoading(true);
    }

    try {
      const payload = {
        id: id,
        gender: filters.gender || "",
        batch_name: filters.batch_name || "",
        medium_studied: filters.medium_studied || "",
        core_subject: filters.core_subject || "",
        panel_mark_status: filters.panel_mark_status ?? "",
        student_mark_status: filters.student_mark_status || "",
      };

      const res = await AxiosInstance.post(
        "api/mockinterview/panel/findById",
        payload
      );

      if (res.data.status === true && res.data.data) {
        const data = res.data.data;

        if (isInitialLoad) {
          setInterViewId(data.id || "");
          setBatchId(data.batch_id || "");
          // Set Interview Details
          setInterviewDetails({
            exam_title: data.exam_title || "",
            started_dt: data.started_dt
              ? moment(data.started_dt).format("DD/MM/YYYY")
              : "",
            category: data.category || "",
            course_name: data.course_name || "",
            syllabus_url: data.syllabus_url || "",
            syllabus_name: data.syllabus_path || "",
            result_status: data.result_status || 0,
            category_course_id: data.category_course_id || "",
            syllabus_path: data.syllabus_path || "",
          });

          const enroll_student = data.enroll_student.length;
          setEnrollMent(enroll_student);

          // Set Panel Details
          if (data.panel_details && data.panel_details.length > 0) {
            const panel = data.panel_details[0];
            setPanelDetails({
              panel_name: panel.panel_name || "",
              panel_venue: panel.panel_venue || "",
              panel_venue_url: panel.panel_venue_url || "",
              core_subject: panel.core_subject || "",
              interview_date: panel.interview_date
                ? moment(panel.interview_date).format("DD/MM/YYYY")
                : "",
              start_time: panel.start_time || "",
              end_time: panel.end_time || "",
              slot_duration: panel.slot_duration || "",
              student_count: panel.student_count || 0,
              mark_status: panel.status,
            });
          }

          // Set Other Applicable Batches
          if (data.otherAppBatch && data.otherAppBatch.length > 0) {
            const batchNames = data.otherAppBatch
              .map((batch) => batch.batch_name)
              .join(", ");
            setOtherApplicableBatches(batchNames);
          } else {
            setOtherApplicableBatches("");
          }
        }

        // ============== MOVE PANEL MEMBERS UPDATE OUTSIDE isInitialLoad ==============
        // Set Panel Members with serial numbers and count data
        // This should run on BOTH initial load AND filter changes
        if (data.panel_member && data.panel_member.length > 0) {
          const members = data.panel_member.map((member, index) => ({
            id: member.faculty_id || index,
            serialNumber: index + 1,
            name: member.faculty_name || "",
            department: member.faculty_department || "-",
            designation: member.faculty_designation || "-",
            phone_number: member.faculty_mobile
              ? member.faculty_mobile.toString()
              : "-",
            email: member.faculty_email || "-",
            total_count: member.total_count || 0,
            update_count: member.update_count || 0,
            status: member.status,
          }));

          if (isInitialLoad) {
            setPanelMembers(members);
          }
          setFilteredPanelMembers(members);
        } else {
          // If no panel members returned (filtered result is empty), show empty
          setFilteredPanelMembers([]);
        }
        // ============== END PANEL MEMBERS UPDATE ==============

        // Set Enrolled Students with serial numbers and count data
        if (data.enroll_student && data.enroll_student.length > 0) {
          const students = data.enroll_student.map((student, index) => ({
            id: student.student_user_id || index,
            serialNumber: index + 1,
            name: student.student_name || "",
            admission_id: student.admission_id || "-",
            admission_pk: student.admission_pk,
            batch_name: student.batch_name || "-",
            phone_number: student.student_mobile
              ? student.student_mobile.toString()
              : "-",
            email: student.student_email || "-",
            student_gender: student.student_gender || "-",
            medium_studied: student.medium_studied || "-",
            core_sub_id: student.core_sub_id,
            core_sub: student.core_sub || "-",
            time_slot: student.time_slot || "-",
            total_panel_count: student.total_panel_count || 0,
            panel_mark_count: student.panel_mark_count || 0,
            mark_status: student.mark_status || "Not Yet Updated",
            attendance_status: student.attendance_status,
            stud_status: student.stud_status || "",
            team_url: student.team_url || null,
            interview_id: student.interview_id || "",
            panel_id: student.panel_id || "",
          }));
          setEnrolledStudents(students);

          if (isInitialLoad) {
            setOriginalEnrolledStudents(students);
            extractFilterOptions(students);
          }
        } else {
          setEnrolledStudents([]);
        }

        setCurrentPage(1);
      }
    } catch (error) {
      console.error("Error fetching panel data:", error);
      if (isInitialLoad) {
        setEnrolledStudents([]);
      }
    } finally {
      setIsLoading(false);
      setIsStudentLoading(false);
    }
  };
  // ============== END API FILTER FUNCTIONS ==============

  // Click outside handlers
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;

      if (
        memberStatusRef.current &&
        !memberStatusRef.current.contains(event.target)
      ) {
        setIsMemberStatusOpen(false);
        setTempMemberStatus(memberStatusFilter);
      }
      if (
        batchNameRef.current &&
        !batchNameRef.current.contains(event.target)
      ) {
        setIsBatchNameOpen(false);
        setTempBatchName(batchNameFilter);
      }
      if (genderRef.current && !genderRef.current.contains(event.target)) {
        setIsGenderOpen(false);
        setTempGender(genderFilter);
      }
      if (mediumRef.current && !mediumRef.current.contains(event.target)) {
        setIsMediumOpen(false);
        setTempMedium(mediumFilter);
      }
      if (
        coreSubjectRef.current &&
        !coreSubjectRef.current.contains(event.target)
      ) {
        setIsCoreSubjectOpen(false);
        setTempCoreSubject(coreSubjectFilter);
      }
      if (
        studentStatusRef.current &&
        !studentStatusRef.current.contains(event.target)
      ) {
        setIsStudentStatusOpen(false);
        setTempStudentStatus(studentStatusFilter);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    memberStatusFilter,
    batchNameFilter,
    genderFilter,
    mediumFilter,
    coreSubjectFilter,
    studentStatusFilter,
  ]);

  // Extract unique filter options from data
  const extractFilterOptions = (students) => {
    const batches = [];
    const genders = [];
    const mediums = [];
    const coreSubjects = [];

    students.forEach((student) => {
      if (
        student.batch_name &&
        student.batch_name !== "-" &&
        !batches.find((b) => b.name === student.batch_name)
      ) {
        batches.push({
          id: student.batch_name,
          name: student.batch_name,
        });
      }
      if (
        student.student_gender &&
        student.student_gender !== "-" &&
        !genders.find((g) => g.name === student.student_gender)
      ) {
        genders.push({
          id: student.student_gender,
          name: student.student_gender,
        });
      }
      if (
        student.medium_studied &&
        student.medium_studied !== "-" &&
        !mediums.find((m) => m.name === student.medium_studied)
      ) {
        mediums.push({
          id: student.medium_studied,
          name: student.medium_studied,
        });
      }
      if (
        student.core_sub &&
        student.core_sub !== "-" &&
        !coreSubjects.find((c) => c.name === student.core_sub)
      ) {
        coreSubjects.push({
          id: student.core_sub_id || student.core_sub,
          name: student.core_sub,
        });
      }
    });

    setBatchNameOptions(batches);
    setGenderOptions(genders);
    setMediumOptions(mediums);
    setCoreSubjectOptions(coreSubjects);
  };

  // Panel Member Filter Handlers
  const handleMemberStatusCheckbox = (e, item) => {
    if (e.target.checked) {
      setTempMemberStatus((prev) => [...prev, item]);
    } else {
      setTempMemberStatus((prev) => prev.filter((f) => f.id !== item.id));
    }
  };

  const handleNavigate = (panelId) => {
    navigate(`/PanelInfoCreate/${panelId}`, {
      state: {
        INTERVIEW_ID: interviewId || INTERVIEWID,
        BATCH_ID: batchId || BATCHID,
        CATEGORY_COURSE_ID: interviewDetails.category_course_id || "",
        CATEGORY: interviewDetails.category || "",
      },
    });
  };

  // Apply Panel Member Status Filter - API based
  const handleApplyMemberStatusFilter = () => {
    setMemberStatusFilter(tempMemberStatus);
    setIsMemberStatusOpen(false);

    const newChips = tempMemberStatus.map((item) => ({
      name: item.name,
      type: "member_status",
      id: item.id,
    }));

    setMemberChipData((prev) => {
      const filtered = prev.filter((chip) => chip.type !== "member_status");
      return [...filtered, ...newChips];
    });

    // Call API with all current filters including member status
    const filterPayload = buildFilterPayloadFromStates(
      batchNameFilter,
      genderFilter,
      mediumFilter,
      coreSubjectFilter,
      studentStatusFilter,
      tempMemberStatus // Pass the member status filter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  const handleClearMemberStatusFilter = () => {
    setTempMemberStatus([]);
    setMemberStatusFilter([]);
    setIsMemberStatusOpen(false);
    setMemberChipData((prev) =>
      prev.filter((chip) => chip.type !== "member_status")
    );

    // Call API with cleared member status filter
    const filterPayload = buildFilterPayloadFromStates(
      batchNameFilter,
      genderFilter,
      mediumFilter,
      coreSubjectFilter,
      studentStatusFilter,
      [] // Empty member status filter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  // Delete member chip - API based
  const handleDeleteMemberChip = (chipToDelete) => {
    setMemberChipData((prev) =>
      prev.filter((chip) => chip.id !== chipToDelete.id)
    );
    const newFilter = memberStatusFilter.filter(
      (item) => item.id !== chipToDelete.id
    );
    setMemberStatusFilter(newFilter);
    setTempMemberStatus(newFilter);

    // Call API with updated member status filter
    const filterPayload = buildFilterPayloadFromStates(
      batchNameFilter,
      genderFilter,
      mediumFilter,
      coreSubjectFilter,
      studentStatusFilter,
      newFilter // Updated member status filter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  // Clear all member chips - API based
  const handleClearAllMemberChips = () => {
    setMemberChipData([]);
    setMemberStatusFilter([]);
    setTempMemberStatus([]);

    // Call API with cleared member status filter
    const filterPayload = buildFilterPayloadFromStates(
      batchNameFilter,
      genderFilter,
      mediumFilter,
      coreSubjectFilter,
      studentStatusFilter,
      [] // Empty member status filter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  // ============== STUDENT FILTER HANDLERS (API-based) ==============

  const handleStudentCheckbox = (e, item, type, setTemp) => {
    if (type === "medium") {
      // Single select for medium - only one can be selected
      if (e.target.checked) {
        setTemp([item]);
      } else {
        setTemp([]);
      }
    } else {
      // Multi select for other filters
      if (e.target.checked) {
        setTemp((prev) => [...prev, item]);
      } else {
        setTemp((prev) => prev.filter((f) => f.id !== item.id));
      }
    }
  };

  const handleApplyStudentFilter = (type, tempValues, setFilter, setIsOpen) => {
    setFilter(tempValues);
    setIsOpen(false);

    const newChips = tempValues.map((item) => ({
      name: item.name,
      type: type,
      id: item.id,
    }));

    let updatedChipData = studentChipData.filter((chip) => chip.type !== type);
    updatedChipData = [...updatedChipData, ...newChips];
    setStudentChipData(updatedChipData);

    // Build payload using current filter states with the new tempValues for the current type
    const currentBatchFilter =
      type === "batch_name" ? tempValues : batchNameFilter;
    const currentGenderFilter = type === "gender" ? tempValues : genderFilter;
    const currentMediumFilter = type === "medium" ? tempValues : mediumFilter;
    const currentCoreSubjectFilter =
      type === "core_subject" ? tempValues : coreSubjectFilter;
    const currentStudentStatusFilter =
      type === "student_status" ? tempValues : studentStatusFilter;

    const filterPayload = buildFilterPayloadFromStates(
      currentBatchFilter,
      currentGenderFilter,
      currentMediumFilter,
      currentCoreSubjectFilter,
      currentStudentStatusFilter,
      memberStatusFilter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  const handleClearStudentFilter = (type, setTemp, setFilter, setIsOpen) => {
    setTemp([]);
    setFilter([]);
    setIsOpen(false);

    const updatedChipData = studentChipData.filter(
      (chip) => chip.type !== type
    );
    setStudentChipData(updatedChipData);

    // Build payload using current filter states with empty array for the cleared type
    const currentBatchFilter = type === "batch_name" ? [] : batchNameFilter;
    const currentGenderFilter = type === "gender" ? [] : genderFilter;
    const currentMediumFilter = type === "medium" ? [] : mediumFilter;
    const currentCoreSubjectFilter =
      type === "core_subject" ? [] : coreSubjectFilter;
    const currentStudentStatusFilter =
      type === "student_status" ? [] : studentStatusFilter;

    const filterPayload = buildFilterPayloadFromStates(
      currentBatchFilter,
      currentGenderFilter,
      currentMediumFilter,
      currentCoreSubjectFilter,
      currentStudentStatusFilter,
      memberStatusFilter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  const handleDeleteStudentChip = (chipToDelete) => {
    const updatedChipData = studentChipData.filter(
      (chip) =>
        !(chip.id === chipToDelete.id && chip.type === chipToDelete.type)
    );
    setStudentChipData(updatedChipData);

    let currentBatchFilter = batchNameFilter;
    let currentGenderFilter = genderFilter;
    let currentMediumFilter = mediumFilter;
    let currentCoreSubjectFilter = coreSubjectFilter;
    let currentStudentStatusFilter = studentStatusFilter;

    if (chipToDelete.type === "batch_name") {
      const newFilter = batchNameFilter.filter(
        (item) => item.id !== chipToDelete.id
      );
      setBatchNameFilter(newFilter);
      setTempBatchName(newFilter);
      currentBatchFilter = newFilter;
    } else if (chipToDelete.type === "gender") {
      const newFilter = genderFilter.filter(
        (item) => item.id !== chipToDelete.id
      );
      setGenderFilter(newFilter);
      setTempGender(newFilter);
      currentGenderFilter = newFilter;
    } else if (chipToDelete.type === "medium") {
      const newFilter = mediumFilter.filter(
        (item) => item.id !== chipToDelete.id
      );
      setMediumFilter(newFilter);
      setTempMedium(newFilter);
      currentMediumFilter = newFilter;
    } else if (chipToDelete.type === "core_subject") {
      const newFilter = coreSubjectFilter.filter(
        (item) => item.id !== chipToDelete.id
      );
      setCoreSubjectFilter(newFilter);
      setTempCoreSubject(newFilter);
      currentCoreSubjectFilter = newFilter;
    } else if (chipToDelete.type === "student_status") {
      const newFilter = studentStatusFilter.filter(
        (item) => item.id !== chipToDelete.id
      );
      setStudentStatusFilter(newFilter);
      setTempStudentStatus(newFilter);
      currentStudentStatusFilter = newFilter;
    }

    const filterPayload = buildFilterPayloadFromStates(
      currentBatchFilter,
      currentGenderFilter,
      currentMediumFilter,
      currentCoreSubjectFilter,
      currentStudentStatusFilter,
      memberStatusFilter
    );

    fetchPanelDataWithFilters(filterPayload, false);
  };

  const handleClearAllStudentChips = () => {
    setStudentChipData([]);
    setBatchNameFilter([]);
    setTempBatchName([]);
    setGenderFilter([]);
    setTempGender([]);
    setMediumFilter([]);
    setTempMedium([]);
    setCoreSubjectFilter([]);
    setTempCoreSubject([]);
    setStudentStatusFilter([]);
    setTempStudentStatus([]);

    // const filterPayload = buildFilterPayloadFromStates([], [], [], [], [], []);
    const filterPayload = buildFilterPayloadFromStates(
      [],
      [],
      [],
      [],
      [],
      memberStatusFilter
    );
    fetchPanelDataWithFilters(filterPayload, false);
  };

  // ============== END STUDENT FILTER HANDLERS ==============

  // Pagination Handlers
  const handlePrev = (val) => {
    setCurrentPage(val);
  };

  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  // Helper function to parse "04:30 PM" into hours/minutes
  const parseTime = (timeStr) => {
    const [time, meridian] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (meridian === "PM" && hours !== 12) hours += 12;
    if (meridian === "AM" && hours === 12) hours = 0;

    return { hours, minutes };
  };

  const isViewEnabled = (timeSlot, started_dt) => {
    if (!timeSlot || !started_dt) return false;

    const currentTime = new Date();

    // Parse interview date from DD/MM/YYYY
    const [day, month, year] = started_dt.split("/");
    const interviewDate = new Date(year, month - 1, day);

    // Extract slot start time
    const [startStr] = timeSlot.split(" - ");
    const { hours, minutes } = parseTime(startStr);

    // Slot start datetime
    const slotStartTime = new Date(interviewDate);
    slotStartTime.setHours(hours, minutes, 0, 0);

    // Enable 30 minutes before slot
    const enableTime = new Date(slotStartTime.getTime() - 30 * 60 * 1000);

    // ✅ SAME behavior for Admin & Non-Admin
    if (user_type === 1 || [3, 4, 5].includes(user_type)) {
      return currentTime >= enableTime;
    }

    return false;
  };

  // Handle View Student Details
  const handleViewStudent = (studentId, admission_pk, data) => {
    navigate(`/ViewStudentDetails/${studentId}`, {
      state: {
        PANELID: data.panel_id ? data.panel_id : id,
        INTERVIEWID: data.interview_id
          ? data.interview_id
          : interviewId || INTERVIEWID,
        MARKSTATUS: MARKSTATUS,
        BATCHID: BATCHID,
        FCAT: FCAT,
        FCOURSE: FCOURSE,
        FSTATUS: FSTATUS,
        FSEARCH: FSEARCH,
        FDATE: FDATE,
        FILTER_BATCH_NAME: batchNameFilter,
        FILTER_GENDER: genderFilter,
        FILTER_MEDIUM: mediumFilter,
        FILTER_CORE_SUBJECT: coreSubjectFilter,
        FILTER_STUDENT_STATUS: studentStatusFilter,
        FILTER_CHIP_DATA: studentChipData,
        ADMISSION_ID: admission_pk,
        TYPE: TYPE,
        TEAMURL: data.team_url,
        PAGE_FROM: PAGE_FROM,
        PANEL_MARK_STATUS: PANEL_MARK_STATUS,
        UPDATE_MARK: interviewDetails.result_status,
        ID: ID,
      },
    });
  };

  const handleSyllabusDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${url}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Syllabus download failed:", error);
      });
  };

  // Initial data fetch
  useEffect(() => {
    if (!id) {
      console.error("No panel ID available");
      setIsLoading(false);
      return;
    }

    // ALWAYS fetch without filters first to get all filter options
    const fetchInitialData = async () => {
      setIsLoading(true);

      try {
        // First API call - get ALL data for filter options
        const payload = {
          id: id,
          gender: "",
          batch_name: "",
          medium_studied: "",
          core_subject: "",
          panel_mark_status: "",
          student_mark_status: "",
        };

        const res = await AxiosInstance.post(
          "api/mockinterview/panel/findById",
          payload
        );

        if (res.data.status === true && res.data.data) {
          const data = res.data.data;

          setInterViewId(data.id || "");
          setBatchId(data.batch_id || "");

          // Set Interview Details
          setInterviewDetails({
            exam_title: data.exam_title || "",
            started_dt: data.started_dt
              ? moment(data.started_dt).format("DD/MM/YYYY")
              : "",
            category: data.category || "",
            course_name: data.course_name || "",
            syllabus_url: data.syllabus_url || "",
            syllabus_name: data.syllabus_path || "",
            result_status: data.result_status || "",
            syllabus_path: data.syllabus_path || "",
          });

          const enroll_student = data.enroll_student?.length || 0;
          setEnrollMent(enroll_student);

          // Set Panel Details
          if (data.panel_details && data.panel_details.length > 0) {
            const panel = data.panel_details[0];
            setPanelDetails({
              panel_name: panel.panel_name || "",
              panel_venue: panel.panel_venue || "",
              panel_venue_url: panel.panel_venue_url || "",
              core_subject: panel.core_subject || "",
              interview_date: panel.interview_date
                ? moment(panel.interview_date).format("DD/MM/YYYY")
                : "",
              start_time: panel.start_time || "",
              end_time: panel.end_time || "",
              slot_duration: panel.slot_duration || "",
              student_count: panel.student_count || 0,
            });
          }

          // Set Panel Members
          if (data.panel_member && data.panel_member.length > 0) {
            const members = data.panel_member.map((member, index) => ({
              id: member.faculty_id || index,
              serialNumber: index + 1,
              name: member.faculty_name || "",
              department: member.faculty_department || "-",
              designation: member.faculty_designation || "-",
              phone_number: member.faculty_mobile
                ? member.faculty_mobile.toString()
                : "-",
              email: member.faculty_email || "-",
              total_count: member.total_count || 0,
              update_count: member.update_count || 0,
              status: member.status,
            }));
            setPanelMembers(members);
            setFilteredPanelMembers(members);
          }

          // Set Other Applicable Batches
          if (data.otherAppBatch && data.otherAppBatch.length > 0) {
            const batchNames = data.otherAppBatch
              .map((batch) => batch.batch_name)
              .join(", ");
            setOtherApplicableBatches(batchNames);
          } else {
            setOtherApplicableBatches("");
          }

          // Set Enrolled Students
          if (data.enroll_student && data.enroll_student.length > 0) {
            const students = data.enroll_student.map((student, index) => ({
              id: student.student_user_id || index,
              serialNumber: index + 1,
              name: student.student_name || "",
              admission_id: student.admission_id || "-",
              admission_pk: student.admission_pk,
              batch_name: student.batch_name || "-",
              phone_number: student.student_mobile
                ? student.student_mobile.toString()
                : "-",
              email: student.student_email || "-",
              student_gender: student.student_gender || "-",
              medium_studied: student.medium_studied || "-",
              core_sub_id: student.core_sub_id,
              core_sub: student.core_sub || "-",
              time_slot: student.time_slot || "-",
              total_panel_count: student.total_panel_count || 0,
              panel_mark_count: student.panel_mark_count || 0,
              mark_status: student.mark_status || "Not Yet Updated",
              attendance_status: student.attendance_status,
              stud_status: student.stud_status || "",
              team_url: student.team_url || null,
              interview_id: student.interview_id || "",
              panel_id: student.panel_id || "",
            }));

            setOriginalEnrolledStudents(students);
            // ALWAYS extract filter options from FULL data
            extractFilterOptions(students);

            // If no saved filters, show all students
            if (!FILTER_CHIP_DATA || FILTER_CHIP_DATA.length === 0) {
              setEnrolledStudents(students);
            }
          }

          // If there are saved filters, apply them now
          if (FILTER_CHIP_DATA && FILTER_CHIP_DATA.length > 0) {
            const filterPayload = buildFilterPayloadFromStates(
              FILTER_BATCH_NAME || [],
              FILTER_GENDER || [],
              FILTER_MEDIUM || [],
              FILTER_CORE_SUBJECT || [],
              FILTER_STUDENT_STATUS || [],
              []
            );
            // Fetch filtered data (isInitialLoad = false to skip re-extracting options)
            fetchPanelDataWithFilters(filterPayload, false);
          }
        }
      } catch (error) {
        console.error("Error fetching initial panel data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, [id]);

  // const navigateToPreviousScreen = () => {
  //   if (TYPE === "PanelList") {
  //     navigate(`/Panellist`);
  //   } else {
  //     navigate(`/ViewInterviewDetails/${BATCHID}/${INTERVIEWID}`, {
  //       state: {
  //         MARKSTATUS: MARKSTATUS,
  //         filBatchId: BATCHID,
  //         filInterviewId: INTERVIEWID,
  //         filStatus: MARKSTATUS,
  //         TYPE: TYPE,
  //         ID: ID,
  //         // Add this to ensure filter state is passed
  //       },
  //     });
  //   }
  // };

  const navigateToPreviousScreen = () => {
    if (TYPE === "PanelList") {
      navigate(`/Panellist`, {
        state: {
          FCAT: FCAT,
          FCOURSE: FCOURSE,
          FSTATUS: FSTATUS,
          FSEARCH: FSEARCH,
          FDATE: FDATE,
        },
      });
    } else {
      navigate(`/ViewInterviewDetails/${BATCHID}/${INTERVIEWID}`, {
        state: {
          MARKSTATUS: MARKSTATUS,
          filBatchId: BATCHID,
          filInterviewId: INTERVIEWID,
          filStatus: MARKSTATUS,
          TYPE: TYPE,
          ID: ID,
        },
      });
    }
  };
  if (isLoading) {
    return (
      <div
        className="loaderApi"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "white",
          zIndex: 999,
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <React.Fragment>
      <style>
        {`
          
          .active_icons {
            background-color: #c0272d;
            border-radius: 2px;
            color: #fff !important;
          }

          .studentTableLoader {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 200px;
          }

          .sortable {
            cursor: pointer;
          }

        
        `}
      </style>
      <div className={ViewInfo.CourseInfoSec + " BathHeader global_container"}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Panel</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  onClick={navigateToPreviousScreen}
                  to="javascript:void(0)"
                  className="secondaryButton"
                >
                  {TYPE === "PanelList"
                    ? " Back to Panel List"
                    : " Back to View Interview"}
                </Link>
              </li>
              {user_type === 1 && (
                <li className="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={() => handleNavigate(id)}
                    className={`primaryButton ${
                      interviewDetails?.result_status === 1
                        ? ViewInfo.disabledBtn
                        : ""
                    }`}
                    variant="primary"
                  >
                    <span className="material-icons me-1 fs-5 align-middle text-white">
                      border_color
                    </span>
                    Edit Panel
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="mb-4">
          {/* Interview Details Section - Conditionally Rendered */}
          {PAGE_FROM === "l" && (
            <fieldset className="mt-3">
              <legend className="w-auto">Interview Details</legend>
              <div className="row mb-3">
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Interview Title</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {interviewDetails.exam_title || "_"}
                    </p>
                  </div>
                </div>

                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Interview Date</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {interviewDetails.started_dt || "_"}
                    </p>
                  </div>
                </div>

                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Category</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {interviewDetails.category || "_"}
                    </p>
                  </div>
                </div>

                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Course</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {interviewDetails.course_name || "_"}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex">
                      <p className="confirm_label m-0 p-0">Upload Syllabus</p>
                      {interviewDetails?.syllabus_url && (
                        <span
                          className="material-icons align-middle download_icon"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            window.open(
                              `${ImageUrlPrefix}/${interviewDetails.syllabus_url}`,
                              "_blank"
                            )
                          }
                        >
                          file_download
                        </span>
                      )}
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {interviewDetails?.syllabus_name || "_"}
                    </p>
                  </div>
                </div>

                {user_type == 1 && (
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">Interview Status</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {interviewDetails?.result_status === 1
                          ? "Updated"
                          : interviewDetails?.result_status === 0
                          ? "Not Yet Updated"
                          : "_"}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </fieldset>
          )}

          {/* Panel Details Section */}
          <fieldset className="mt-3">
            <legend className="w-auto">Panel Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Panel Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {panelDetails.panel_name || "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Venue</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {panelDetails.panel_venue || "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Venue URL</p>
                  <p
                    className="confirm_value my-1 m-0 p-0"
                    style={{ wordBreak: "break-all" }}
                  >
                    {panelDetails.panel_venue_url || "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Core Subjects</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {panelDetails.core_subject || "_"}
                  </p>
                </div>
              </div>

              {PAGE_FROM !== "l" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Interview Date</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {panelDetails.interview_date || "_"}
                    </p>
                  </div>
                </div>
              )}

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Time</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {panelDetails.start_time && panelDetails.end_time
                      ? formatTimeTo12Hour(panelDetails.start_time) +
                        " to " +
                        formatTimeTo12Hour(panelDetails.end_time)
                      : "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    Slot Duration (In Minutes)
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formatSlotDuration(panelDetails.slot_duration) || "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Mark Status</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {PANEL_MARK_STATUS !== undefined &&
                    PANEL_MARK_STATUS !== null
                      ? PANEL_MARK_STATUS == 1
                        ? "Updated"
                        : PANEL_MARK_STATUS == 0
                        ? "Not Yet Updated"
                        : "_"
                      : panelDetails.mark_status === 1
                      ? "Updated"
                      : panelDetails.mark_status === 0
                      ? "Not Yet Updated"
                      : "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Enrolled Students</p>
                  <p className="confirm_value my-1 m-0 p-0">{enrollMent}</p>
                </div>
              </div>
            </div>
          </fieldset>

          {/* Panel Members Section */}
          <fieldset className="mt-3">
            <legend className="w-auto">Panel Members</legend>

            {/* Member Chips */}
            {memberChipData.length > 0 && (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {memberChipData.map((data, index) => (
                      <ListItem key={index}>
                        <Chip
                          label={data.name}
                          onDelete={() => handleDeleteMemberChip(data)}
                        />
                      </ListItem>
                    ))}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleClearAllMemberChips}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            )}

            <div
              className={
                ViewInfo.cm_ListViewForm +
                " container-fluid global_container p-0"
              }
            >
              <div className="row mx-0 mt-2">
                <div className="col-md-12 table-responsive tableMinHeight px-0">
                  <table className="table" id="tableListHeader">
                    <thead>
                      <tr>
                        <th id="th">
                          <span
                            className="textHead_th sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "serialNumber")
                            }
                          >
                            S.No
                          </span>
                          <span
                            className="textHead_th material-icons align-middle sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "serialNumber")
                            }
                          >
                            import_export
                          </span>
                        </th>

                        <th id="th">
                          <span
                            className="textHead_th sortable"
                            onClick={(e) => handleSortPanelMembers(e, "name")}
                          >
                            Name
                          </span>
                          <span
                            className="textHead_th material-icons align-middle sortable"
                            onClick={(e) => handleSortPanelMembers(e, "name")}
                          >
                            import_export
                          </span>
                        </th>

                        <th id="th">
                          <span
                            className="textHead_th sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "department")
                            }
                          >
                            Department
                          </span>
                          <span
                            className="textHead_th material-icons align-middle sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "department")
                            }
                          >
                            import_export
                          </span>
                        </th>

                        <th id="th">
                          <span
                            className="textHead_th sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "designation")
                            }
                          >
                            Designation
                          </span>
                          <span
                            className="textHead_th material-icons align-middle sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "designation")
                            }
                          >
                            import_export
                          </span>
                        </th>

                        {user_type === 1 && (
                          <th id="th">
                            <span
                              className="textHead_th sortable"
                              onClick={(e) =>
                                handleSortPanelMembers(e, "phone_number")
                              }
                            >
                              Phone Number
                            </span>
                            <span
                              className="textHead_th material-icons align-middle sortable"
                              onClick={(e) =>
                                handleSortPanelMembers(e, "phone_number")
                              }
                            >
                              import_export
                            </span>
                          </th>
                        )}

                        {user_type === 1 && (
                          <th id="th">
                            <span
                              className="textHead_th sortable"
                              onClick={(e) =>
                                handleSortPanelMembers(e, "email")
                              }
                            >
                              Email
                            </span>
                            <span
                              className="textHead_th material-icons align-middle sortable"
                              onClick={(e) =>
                                handleSortPanelMembers(e, "email")
                              }
                            >
                              import_export
                            </span>
                          </th>
                        )}
                        {/* Mark Status with Filter */}
                        <th id="th" ref={memberStatusRef}>
                          <span
                            className="textHead_th sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "mark_status")
                            }
                          >
                            Mark Status
                          </span>
                          <span
                            className="textHead_th material-icons align-middle sortable"
                            onClick={(e) =>
                              handleSortPanelMembers(e, "mark_status")
                            }
                          >
                            import_export
                          </span>
                          <span
                            className={
                              "textHead_th align-middle material-icons " +
                              (memberStatusFilter.length > 0 ||
                              isMemberStatusOpen
                                ? ViewInfo.active_icons
                                : "")
                            }
                            onClick={() => {
                              setIsMemberStatusOpen(!isMemberStatusOpen);
                              setTempMemberStatus(memberStatusFilter);
                            }}
                          >
                            filter_list
                          </span>

                          {isMemberStatusOpen && (
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {memberStatusOptions.map((item) => (
                                    <li
                                      className="filterListData"
                                      key={item.id}
                                    >
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={item.name}
                                        value={item.id}
                                        id={"member_status_" + item.id}
                                        checked={tempMemberStatus.some(
                                          (f) => f.id === item.id
                                        )}
                                        onChange={(e) =>
                                          handleMemberStatusCheckbox(e, item)
                                        }
                                      />
                                      <label
                                        className={`form-check-label filterChipText ms-3 ${
                                          item.name
                                            ?.toLowerCase()
                                            .includes("not yet")
                                            ? ViewInfo.deliveryStatusPink
                                            : ViewInfo.deliveryStatusGreen
                                        }`}
                                        htmlFor={"member_status_" + item.id}
                                      >
                                        {item.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to="javascript:void(0)"
                                      onClick={handleClearMemberStatusFilter}
                                      className="secondaryButton"
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      to="javascript:void(0)"
                                      onClick={handleApplyMemberStatusFilter}
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                        </th>
                        <th hidden>
                          <span className="textHead_th">Action</span>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredPanelMembers.length === 0 ? (
                        <tr>
                          <td
                            colSpan={user_type === 1 ? 7 : 5}
                            style={{
                              textAlign: "center",
                              borderBottom: "1px solid #dee2e6",
                            }}
                          >
                            No records to display
                          </td>
                        </tr>
                      ) : (
                        filteredPanelMembers.map((member, index) => {
                          const markStatusInfo =
                            getPanelMemberMarkStatus(member);
                          return (
                            <tr key={member.id + "_" + index}>
                              <td id="td">{member.serialNumber}</td>
                              <td id="td">
                                <span
                                  className={ViewInfo.ellipsis}
                                  title={member.name}
                                >
                                  {member.name || "-"}
                                </span>
                              </td>
                              <td id="td">{member.department || "-"}</td>
                              <td id="td">{member.designation || "-"}</td>
                              {user_type === 1 && (
                                <td id="td">{member.phone_number || "-"}</td>
                              )}
                              {user_type === 1 && (
                                <td id="td">
                                  <span
                                    className={ViewInfo.ellipsis}
                                    title={member.email}
                                  >
                                    {member.email || "-"}
                                  </span>
                                </td>
                              )}
                              <td id="td">
                                <span
                                  className={`filterChipText ${
                                    ViewInfo.deliveryStatus
                                  } ${
                                    markStatusInfo.isUpdated
                                      ? ViewInfo.deliveryStatusGreen
                                      : ViewInfo.deliveryStatusPink
                                  }`}
                                >
                                  {markStatusInfo.text}
                                </span>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </fieldset>

          {/* Other Applicable Batches Section */}
          {user_type === 1 && (
            <fieldset className="mt-3">
              <legend className="w-auto">Other Applicable Batches</legend>
              <div className="row mb-3">
                <div className="my-1 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">
                      Other Applicable Batches
                    </p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {otherApplicableBatches || "_"}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          )}

          {/* Enrolled Students Section */}
          <fieldset className="mt-3">
            <legend className="w-auto">Enrolled Student</legend>
            {/* Student Chips */}
            {studentChipData.length > 0 && (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {studentChipData.map((data, index) => (
                      <ListItem key={index}>
                        <Chip
                          label={data.name}
                          onDelete={() => handleDeleteStudentChip(data)}
                        />
                      </ListItem>
                    ))}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleClearAllStudentChips}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            )}

            <div
              className={
                ViewInfo.cm_ListViewForm +
                " container-fluid global_container p-0"
              }
            >
              {isStudentLoading ? (
                <div className="studentTableLoader">
                  <Loader />
                </div>
              ) : (
                <>
                  <div className="row mx-0 mt-2">
                    <div className="col-md-12 table-responsive tableMinHeight px-0">
                      <table className="table" id="tableListHeader">
                        <thead>
                          <tr>
                            <th id="th">
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "serialNumber")
                                }
                              >
                                S.No
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "serialNumber")
                                }
                              >
                                import_export
                              </span>
                            </th>

                            <th id="th">
                              <span
                                className="textHead_th sortable"
                                onClick={(e) => handleSortStudents(e, "name")}
                              >
                                Name
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) => handleSortStudents(e, "name")}
                              >
                                import_export
                              </span>
                            </th>
                            {user_type === 1 && (
                              <th id="th">
                                <span
                                  className="textHead_th sortable"
                                  onClick={(e) =>
                                    handleSortStudents(e, "admission_id")
                                  }
                                >
                                  Admission ID
                                </span>
                                <span
                                  className="textHead_th material-icons align-middle sortable"
                                  onClick={(e) =>
                                    handleSortStudents(e, "admission_id")
                                  }
                                >
                                  import_export
                                </span>
                              </th>
                            )}

                            {/* Batch Name with Filter */}
                            <th id="th" ref={batchNameRef}>
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "batch_name")
                                }
                              >
                                Batch Name
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "batch_name")
                                }
                              >
                                import_export
                              </span>
                              <span
                                className={
                                  "textHead_th align-middle material-icons " +
                                  (batchNameFilter.length > 0 || isBatchNameOpen
                                    ? ViewInfo.active_icons
                                    : "")
                                }
                                onClick={() => {
                                  setIsBatchNameOpen(!isBatchNameOpen);
                                  setIsGenderOpen(false);
                                  setIsMediumOpen(false);
                                  setIsCoreSubjectOpen(false);
                                  setIsStudentStatusOpen(false);
                                  setTempBatchName(batchNameFilter);
                                }}
                              >
                                filter_list
                              </span>

                              {isBatchNameOpen && (
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {batchNameOptions.map((item) => (
                                        <li
                                          className="filterListData"
                                          key={item.id}
                                        >
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={item.name}
                                            value={item.id}
                                            id={"batch_" + item.id}
                                            checked={tempBatchName.some(
                                              (f) => f.id === item.id
                                            )}
                                            onChange={(e) =>
                                              handleStudentCheckbox(
                                                e,
                                                item,
                                                "batch_name",
                                                setTempBatchName
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG"
                                            htmlFor={"batch_" + item.id}
                                          >
                                            {item.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleClearStudentFilter(
                                              "batch_name",
                                              setTempBatchName,
                                              setBatchNameFilter,
                                              setIsBatchNameOpen
                                            )
                                          }
                                          className="secondaryButton"
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleApplyStudentFilter(
                                              "batch_name",
                                              tempBatchName,
                                              setBatchNameFilter,
                                              setIsBatchNameOpen
                                            )
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </th>
                            {user_type === 1 && (
                              <th id="th">
                                <span
                                  className="textHead_th sortable"
                                  onClick={(e) =>
                                    handleSortStudents(e, "phone_number")
                                  }
                                >
                                  Phone Number
                                </span>
                                <span
                                  className="textHead_th material-icons align-middle sortable"
                                  onClick={(e) =>
                                    handleSortStudents(e, "phone_number")
                                  }
                                >
                                  import_export
                                </span>
                              </th>
                            )}

                            {user_type === 1 && (
                              <th id="th">
                                <span
                                  className="textHead_th sortable"
                                  onClick={(e) =>
                                    handleSortStudents(e, "email")
                                  }
                                >
                                  Email
                                </span>
                                <span
                                  className="textHead_th material-icons align-middle sortable"
                                  onClick={(e) =>
                                    handleSortStudents(e, "email")
                                  }
                                >
                                  import_export
                                </span>
                              </th>
                            )}

                            {/* Gender with Filter */}
                            <th id="th" ref={genderRef}>
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "student_gender")
                                }
                              >
                                Gender
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "student_gender")
                                }
                              >
                                import_export
                              </span>
                              <span
                                className={
                                  "textHead_th align-middle material-icons " +
                                  (genderFilter.length > 0 || isGenderOpen
                                    ? ViewInfo.active_icons
                                    : "")
                                }
                                onClick={() => {
                                  setIsGenderOpen(!isGenderOpen);
                                  setIsBatchNameOpen(false);
                                  setIsMediumOpen(false);
                                  setIsCoreSubjectOpen(false);
                                  setIsStudentStatusOpen(false);
                                  setTempGender(genderFilter);
                                }}
                              >
                                filter_list
                              </span>

                              {isGenderOpen && (
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {genderOptions.map((item) => (
                                        <li
                                          className="filterListData"
                                          key={item.id}
                                        >
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={item.name}
                                            value={item.id}
                                            id={"gender_" + item.id}
                                            checked={tempGender.some(
                                              (f) => f.id === item.id
                                            )}
                                            onChange={(e) =>
                                              handleStudentCheckbox(
                                                e,
                                                item,
                                                "gender",
                                                setTempGender
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG"
                                            htmlFor={"gender_" + item.id}
                                          >
                                            {item.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleClearStudentFilter(
                                              "gender",
                                              setTempGender,
                                              setGenderFilter,
                                              setIsGenderOpen
                                            )
                                          }
                                          className="secondaryButton"
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleApplyStudentFilter(
                                              "gender",
                                              tempGender,
                                              setGenderFilter,
                                              setIsGenderOpen
                                            )
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </th>

                            {/* Medium Studied with Filter */}
                            <th id="th" ref={mediumRef}>
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "medium_studied")
                                }
                              >
                                Medium Studied
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "medium_studied")
                                }
                              >
                                import_export
                              </span>
                              <span
                                className={
                                  "textHead_th align-middle material-icons " +
                                  (mediumFilter.length > 0 || isMediumOpen
                                    ? ViewInfo.active_icons
                                    : "")
                                }
                                onClick={() => {
                                  setIsMediumOpen(!isMediumOpen);
                                  setIsBatchNameOpen(false);
                                  setIsGenderOpen(false);
                                  setIsCoreSubjectOpen(false);
                                  setIsStudentStatusOpen(false);
                                  setTempMedium(mediumFilter);
                                }}
                              >
                                filter_list
                              </span>

                              {isMediumOpen && (
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {mediumOptions.map((item) => (
                                        <li
                                          className="filterListData"
                                          key={item.id}
                                        >
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={item.name}
                                            value={item.id}
                                            id={"medium_" + item.id}
                                            checked={tempMedium.some(
                                              (f) => f.id === item.id
                                            )}
                                            onChange={(e) =>
                                              handleStudentCheckbox(
                                                e,
                                                item,
                                                "medium",
                                                setTempMedium
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG"
                                            htmlFor={"medium_" + item.id}
                                          >
                                            {item.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleClearStudentFilter(
                                              "medium",
                                              setTempMedium,
                                              setMediumFilter,
                                              setIsMediumOpen
                                            )
                                          }
                                          className="secondaryButton"
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleApplyStudentFilter(
                                              "medium",
                                              tempMedium,
                                              setMediumFilter,
                                              setIsMediumOpen
                                            )
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </th>

                            {/* Core Subject with Filter */}
                            <th id="th" ref={coreSubjectRef}>
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "core_sub")
                                }
                              >
                                Core Subject
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "core_sub")
                                }
                              >
                                import_export
                              </span>
                              <span
                                className={
                                  "textHead_th align-middle material-icons " +
                                  (coreSubjectFilter.length > 0 ||
                                  isCoreSubjectOpen
                                    ? ViewInfo.active_icons
                                    : "")
                                }
                                onClick={() => {
                                  setIsCoreSubjectOpen(!isCoreSubjectOpen);
                                  setIsBatchNameOpen(false);
                                  setIsGenderOpen(false);
                                  setIsMediumOpen(false);
                                  setIsStudentStatusOpen(false);
                                  setTempCoreSubject(coreSubjectFilter);
                                }}
                              >
                                filter_list
                              </span>

                              {isCoreSubjectOpen && (
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {coreSubjectOptions.map((item) => (
                                        <li
                                          className="filterListData"
                                          key={item.id}
                                        >
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={item.name}
                                            value={item.id}
                                            id={"core_" + item.id}
                                            checked={tempCoreSubject.some(
                                              (f) => f.id === item.id
                                            )}
                                            onChange={(e) =>
                                              handleStudentCheckbox(
                                                e,
                                                item,
                                                "core_subject",
                                                setTempCoreSubject
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG"
                                            htmlFor={"core_" + item.id}
                                          >
                                            {item.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleClearStudentFilter(
                                              "core_subject",
                                              setTempCoreSubject,
                                              setCoreSubjectFilter,
                                              setIsCoreSubjectOpen
                                            )
                                          }
                                          className="secondaryButton"
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleApplyStudentFilter(
                                              "core_subject",
                                              tempCoreSubject,
                                              setCoreSubjectFilter,
                                              setIsCoreSubjectOpen
                                            )
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </th>

                            <th id="th">
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "time_slot")
                                }
                              >
                                Time Slot
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "time_slot")
                                }
                              >
                                import_export
                              </span>
                            </th>

                            {/* Mark Status with Filter */}
                            <th id="th" ref={studentStatusRef}>
                              <span
                                className="textHead_th sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "mark_status")
                                }
                              >
                                Mark Status
                              </span>
                              <span
                                className="textHead_th material-icons align-middle sortable"
                                onClick={(e) =>
                                  handleSortStudents(e, "mark_status")
                                }
                              >
                                import_export
                              </span>
                              <span
                                className={
                                  "textHead_th align-middle material-icons " +
                                  (studentStatusFilter.length > 0 ||
                                  isStudentStatusOpen
                                    ? ViewInfo.active_icons
                                    : "")
                                }
                                onClick={() => {
                                  setIsStudentStatusOpen(!isStudentStatusOpen);
                                  setIsBatchNameOpen(false);
                                  setIsGenderOpen(false);
                                  setIsMediumOpen(false);
                                  setIsCoreSubjectOpen(false);
                                  setTempStudentStatus(studentStatusFilter);
                                }}
                              >
                                filter_list
                              </span>

                              {isStudentStatusOpen && (
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {studentStatusOptions.map((item) => (
                                        <li
                                          className="filterListData"
                                          key={item.id}
                                        >
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={item.name}
                                            value={item.id}
                                            id={"student_status_" + item.id}
                                            checked={tempStudentStatus.some(
                                              (f) => f.id === item.id
                                            )}
                                            onChange={(e) =>
                                              handleStudentCheckbox(
                                                e,
                                                item,
                                                "student_status",
                                                setTempStudentStatus
                                              )
                                            }
                                          />
                                          <label
                                            className={`form-check-label filterChipText ms-3 ${
                                              item.id === 0
                                                ? ViewInfo.deliveryStatusPink
                                                : item.id === 1
                                                ? ViewInfo.deliveryStatusGreen
                                                : ViewInfo.statusAbsent
                                            }`}
                                            htmlFor={
                                              "student_status_" + item.id
                                            }
                                          >
                                            {item.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleClearStudentFilter(
                                              "student_status",
                                              setTempStudentStatus,
                                              setStudentStatusFilter,
                                              setIsStudentStatusOpen
                                            )
                                          }
                                          className="secondaryButton"
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            handleApplyStudentFilter(
                                              "student_status",
                                              tempStudentStatus,
                                              setStudentStatusFilter,
                                              setIsStudentStatusOpen
                                            )
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </th>

                            <th id="th">
                              <span className="textHead_th">Action</span>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentStudentData.length === 0 ? (
                            <tr>
                              <td
                                colSpan="12"
                                style={{
                                  textAlign: "center",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                No records to display
                              </td>
                            </tr>
                          ) : (
                            currentStudentData.map((student, index) => {
                              const markStatusInfo =
                                getStudentMarkStatus(student);
                              return (
                                <tr key={student.id + "_" + index}>
                                  <td id="td">{student.serialNumber}</td>
                                  <td id="td">
                                    <span
                                      className={ViewInfo.ellipsis}
                                      title={student.name}
                                    >
                                      {student.name || "-"}
                                    </span>
                                  </td>
                                  {user_type === 1 && (
                                    <td id="td">
                                      {student.admission_id || "-"}
                                    </td>
                                  )}

                                  <td id="td">{student.batch_name || "-"}</td>
                                  {user_type === 1 && (
                                    <td id="td">
                                      {student.phone_number || "-"}
                                    </td>
                                  )}
                                  {user_type === 1 && (
                                    <td id="td">
                                      <span
                                        className={ViewInfo.ellipsis}
                                        title={student.email}
                                      >
                                        {student.email || "-"}
                                      </span>
                                    </td>
                                  )}

                                  <td id="td">
                                    {student.student_gender || "-"}
                                  </td>
                                  <td id="td">
                                    {student.medium_studied || "-"}
                                  </td>
                                  <td id="td">{student.core_sub || "-"}</td>
                                  <td id="td">{student.time_slot || "-"}</td>
                                  <td id="td">
                                    <span
                                      className={`filterChipText ${
                                        markStatusInfo.status === "updated"
                                          ? ViewInfo.deliveryStatusGreen
                                          : markStatusInfo.status === "absent"
                                          ? ViewInfo.statusAbsent
                                          : ViewInfo.deliveryStatusPink
                                      }`}
                                    >
                                      {markStatusInfo.text}
                                    </span>
                                  </td>

                                  <td id="td">
                                    <button
                                      className={`view_icon_button ${
                                        !isViewEnabled(
                                          student.time_slot,
                                          interviewDetails.started_dt
                                        )
                                          ? ViewInfo.disabledBtn
                                          : ""
                                      }`}
                                      disabled={
                                        !isViewEnabled(
                                          student.time_slot,
                                          interviewDetails.started_dt
                                        )
                                      }
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (
                                          !isViewEnabled(
                                            student.time_slot,
                                            interviewDetails.started_dt
                                          )
                                        )
                                          return;
                                        handleViewStudent(
                                          student.id,
                                          student.admission_pk,
                                          student
                                        );
                                      }}
                                    >
                                      <span className="material-icons">
                                        visibility
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Pagination */}
                  <div className="row mt-2">
                    <Pagination
                      rowsPerPage={rowsPerPage}
                      handlePageCount={handlePageCount}
                      startPage={
                        enrolledStudents?.length > 0
                          ? currentPage * rowsPerPage + 1 - rowsPerPage
                          : 0
                      }
                      endPage={
                        enrolledStudents?.length > 0
                          ? enrolledStudents.length < currentPage * rowsPerPage
                            ? enrolledStudents.length
                            : currentPage * rowsPerPage
                          : 0
                      }
                      totalRecords={enrolledStudents?.length || 0}
                      handlePrev={() => handlePrev(currentPage - 1)}
                      currentPrevPage={currentPage === 1}
                      prevButton={`${ViewInfo.prev_buttonViewEvaluator} ${ViewInfo.materialIconsRightAndLeft} me-2`}
                      handleNext={() => handleNext(currentPage + 1)}
                      currentNextPage={
                        totalPages === 0 || currentPage === totalPages
                      }
                    />
                  </div>
                </>
              )}
            </div>
          </fieldset>
        </div>
      </div>
    </React.Fragment>
  );
}
